export default async function validateMinLength(min: number, value?: string) {
  if (!value || value.length < min) {
    return `Bitte geben Sie mindestens ${min} Zeichen ein.`;
  }
}
